import { createAction, props } from "@ngrx/store";
import { sessionUserData } from "../../interfaces/states-data";

export const __updateSessionUser = createAction(
    '[Session User] Update',
    props<sessionUserData>(),
)

export const __clearSessionUser = createAction(
    '[Session User] Clear'
)